import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

import { AdminService, AdminPatch } from './admin.service';
import { UserService } from '../../dashboard/program-list/user.service';

import { Admin } from './../../models/program/admin';
import { User } from  '../../models/program/user';


@Component({
  selector: 'app-administrators',
  templateUrl: './administrators.component.html',
  styleUrls: ['./administrators.component.less']
})

export class AdministratorsComponent implements OnInit {
  public admins$: Observable<Admin[]>;
  public deleteAdmin: boolean = false;
  public adminToDelete: Admin;
  public selectedUserSettings: User = null;
  public addAdmins: boolean = false;

  constructor(
    private adminService: AdminService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.admins$ = this.adminService.getAdmins();
  }

  public logLink(link: string): void {
    console.log(link);
  }

  public setAdminProperty(id: number, patch: AdminPatch): void {
      this.adminService.patchAdmin(id, patch)
                     .subscribe(() => this.admins$ = this.adminService.getAdmins());
  }

  private openUserSettings(admin: Admin) {
    this.userService.getUser(admin.id)
                    .subscribe(u => this.selectedUserSettings = u);
  }

  public confirmDelete(admin: Admin): void {
    this.adminToDelete = admin;
    this.deleteAdmin = true;
  }

  public cancelDelete(): void {
    this.adminToDelete = null;
    this.deleteAdmin = false;
  }

  public delete(id: number): void {
    this.adminService.deleteAdmin(id)
                     .subscribe(() => {
                       this.deleteAdmin = false;
                       this.adminToDelete = null;
                       this.adminService.getAdmins();
                      });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/administrators/administrators.component.ts